import JobBothSidebarContainer from "../../../components/job/other/JobBothSidebar";

const JobBothSidebar = () => {
  return <JobBothSidebarContainer />;
};

export default JobBothSidebar;
